import { useQuery } from '@tanstack/react-query';
import { ILanguageSection } from '../../Interfaces/ILanguageSection';
import { customFetcher } from '../useFetch';

export const useGetLanguageSections = () => {
  const { data: languageSections, isLoading: isLoadingLanguageSections } =
    useQuery<ILanguageSection[]>({
      queryKey: ['languagesection'],
      queryFn: () => customFetcher({ endpoint: '/languagesection' }),
    });

  return { languageSections, isLoadingLanguageSections };
};
